<ng-template  #template>
  <div class="modal-body">
    <div class="container-fluid">
      <div class="col-xs-12">
        <div class="panel panel-primary">
          <div class="panel-heading">
            <h2 class="panel-title">Application Login</h2>
          </div>
          <div class="panel-body">
            <p>Click the button below to log in to the application. You may be prompted for your LAN credentials</p>
            <div> <button class="btn btn-success" (click)="login()">Login</button> </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>




// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/login/login-modal.component.html